ReportsDashboardController.$inject = ['Club', 'moment'];

/* @ngInject */
function ReportsDashboardController(Club, moment) {
    var vm = this;
    vm.title = 'ReportsDashboardController';
    vm.loading = false;

    vm.today = moment().format('YYYY-MM-DD');

    activate();

    ////////////////

    function activate() {
    }
}

export default ReportsDashboardController;